<script>
    import LoadingScreen from '../common/loading/LoadingScreen.svelte'
    import ErrorScreen from '../common/loading/ErrorScreen.svelte'
    import {getCaptcha} from './captcha'
    import DownloadContent from "./DownloadContent.svelte";
</script>

{#await getCaptcha()}
    <LoadingScreen>Opstuur instructies</LoadingScreen>
{:then captcha}
    <DownloadContent captcha={captcha}/>
{:catch error}
    <ErrorScreen>
        Opstuur instructies
    </ErrorScreen>
{/await}
